import 'js-cloudimage-responsive';
import lazySizes from 'lazysizes';

let ciResponsive;

const initImageLazyLoad = () => {
  if (ciResponsive) {
    ciResponsive.process();

    return;
  }

  lazySizes.cfg.expand = 0;
  lazySizes.cfg.init = false;

  ciResponsive = new window.CIResponsive({
    token: 'image',
    domain: 'agriconomie.com',
    baseUrl: '_img_/',
    lazyLoading: true,
    placeholderBackground: 'transparent',
  });

  lazySizes.init();
};

export default initImageLazyLoad;
